import React from 'react';

const MenuItem = ({ menu, onClick, isActive }) => {
  return (
    <div
      className={`menu-item ${isActive ? 'active' : ''}`}
      onClick={() => onClick(menu)}
    >
      <img src={menu.image_url} alt={menu.name} />
      <h3>{menu.name}</h3>
      <span>{menu.price}€</span>
    </div>
  );
};

export default MenuItem;
